import React from 'react';
import { ArrowBackIos } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';

import { PAYMENT_STEP } from '~common';
import { LocalizationTypography, PromoCodeForm } from '~components/organisms';
import { useOfflineStationEffect } from '~hooks/useOfflineStationEffect';
import { usePaymentStepContext } from '~providers';

export const PromoCodeStep = () => {
  const { handleSetPaymentStep } = usePaymentStepContext();

  useOfflineStationEffect();

  const navigateToRentalPage = () => {
    handleSetPaymentStep(PAYMENT_STEP.RENT_A_CHARGER);
  };

  return (
    <>
      <Stack direction="row">
        <IconButton
          aria-label="back"
          size="small"
          color="inherit"
          sx={{ paddingY: 0 }}
          onClick={navigateToRentalPage}
        >
          <ArrowBackIos />
        </IconButton>
        <LocalizationTypography
          textId="app.rentalPage.newStepThree.selectPaymentMethod.promoTitle"
          defaultText="Add Promo Code"
          variant="Poppins/Heading-3"
        />
      </Stack>

      {/* Promo form */}
      <PromoCodeForm />
    </>
  );
};
